
import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the types for the context state
interface IdentifierContextType {
  lastIdentifier: string | null;
  updateLastIdentifier: (newIdentifier: string) => void;
}

// Create the context with a default value of undefined
const LastIdentifierContext = createContext<IdentifierContextType | undefined>(undefined);

// Custom hook to access the context easily
export const useLastIdentifier = (): IdentifierContextType => {
  const context = useContext(LastIdentifierContext);
  if (!context) {
    throw new Error("useLastIdentifier must be used within an IdentifierProvider");
  }
  return context;
};

// Define the props for the provider component
interface IdentifierProviderProps {
  children: ReactNode;
}

// Context Provider component
export const IdentifierProvider: React.FC<IdentifierProviderProps> = ({ children }) => {
  const [lastIdentifier, setLastIdentifier] = useState<string | null>(null);

  // Function to update lastIdentifier
  const updateLastIdentifier = (newIdentifier: string) => {
    setLastIdentifier(newIdentifier);
  };

  return (
    <LastIdentifierContext.Provider value={{ lastIdentifier, updateLastIdentifier }}>
      {children}
    </LastIdentifierContext.Provider>
  );
};
